export default "<div>{{ GetInterventionStatut(id) }}</div>";